export default "__VITE_ASSET__ac00f8a1__"